﻿import {compositeDisposable, IDisposable} from "../utils/disposable";
import {expressEventListener, expressQuerySelector} from "../common/html";

export interface ICreateReviewLanguageSelectDependencies {
    readonly onSelect: (language: string) => void;
}

export function createReviewLanguageSelect(containerEl: HTMLElement, dependencies: ICreateReviewLanguageSelectDependencies) {
    let eventDisposable: IDisposable;
    const {onSelect} = dependencies;
    const languageSelectEl = expressQuerySelector<HTMLSelectElement>(containerEl, ".technical-review-language-selector", true);
    const deInit = () => eventDisposable && eventDisposable.dispose();

    const init = () => {
        deInit();
        eventDisposable = compositeDisposable(
            [
                expressEventListener(languageSelectEl, "change", () => {
                    onSelect(languageSelectEl.value);
                }),
            ]
        );
    };

    const dispose = () => {
        deInit();
    };

    function selectedLanguage(): string {
        return languageSelectEl.value;
    }

    const updateAmounts = (reviewAmounts: { key: string, value: number }[]) => {
        let totalReviews = 0;
        let languagesCount = 0;

        const replaceAmountBetweenParentheses = (text: string, amount: string): string => {
            return text.replace(/ \([0-9]*?\)/g, ' (' + amount + ')');
        };

        [].slice.call(languageSelectEl.options).forEach(o => {
            const option = o as HTMLOptionElement;
            if (option.value === "all") {
                totalReviews = reviewAmounts.filter(r => r.key === option.value)[0].value;
                option.text = replaceAmountBetweenParentheses(option.text, totalReviews + "");
            } else if (option.value !== "other" && option.value !== "all") {
                const languageCount = reviewAmounts.filter(r => r.key === option.value)[0].value;
                languagesCount += languageCount;
                option.text = replaceAmountBetweenParentheses(option.text, languageCount + "");
            } else if (option.value === "other") {
                option.text = replaceAmountBetweenParentheses(option.text, (totalReviews - languagesCount) + "");
            }
        });
    };

    init();

    return {
        dispose,
        updateAmounts,
        selectedLanguage
    };
}
